import classNames from 'classnames';
import React, { useState, useCallback, useEffect, useRef } from 'react';

type IProps = {
  id: string;
  label?: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
};

const Checkbox: React.FC<IProps> = ({
  id,
  label,
  checked = false,
  indeterminate = false,
  onChange,
}) => {
  const [isChecked, setIsChecked] = useState(checked);
  const checkboxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      // Extract the checked state from event.target before re-render
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const { checked } = event.target;
      setIsChecked(checked);

      // Remove indeterminate state if it exists
      //   if (isIndeterminate) {
      //     setIsIndeterminate(false);
      //   }

      if (onChange) {
        onChange(event, checked); // Use event.target.checked directly
      }
    },
    [onChange],
  );

  const checkboxInputClassNames = classNames([
    'shd-checkbox__input',
    {
      indeterminate,
    },
  ]);

  return (
    <div className="shd-checkbox">
      <input
        id={id}
        ref={checkboxRef}
        className={checkboxInputClassNames}
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
      />
      <label className="shd-checkbox__label" htmlFor={id}>
        <span className="shd-checkbox__box">
          <svg width="10px" height="10px" viewBox="0 0 10 8">
            <polyline
              points={indeterminate ? '2 5 10 5' : '1.5 4 4 7 9 1'} // dash or check svg
              fill="none"
            />
          </svg>
        </span>
        {label && <span className="shd-checkbox__label-text">{label}</span>}
      </label>
    </div>
  );
};

export default React.memo(Checkbox);
